import React, { useEffect, useRef } from "react";
import styled from "styled-components";
import { FontSize, FontWeight, form, prettyScrollbars } from "@glossy";
import { Size, VARIANTS, Variant, padding, radius } from "../../styles";

interface TextAreaProps {
  value: string;
  onChange: (value: string) => void;
  placeholder?: string;
  maxHeight?: number;
  className?: string;
  minHeight?: number;
  size?: Size;
  variant?: Variant;
}

const Input = styled.textarea<{
  maxHeight?: number;
  $size: Size;
  minHeight?: number;
  variant: Variant;
}>`
  width: 100%;
  padding: ${padding}px;
  min-height: ${(props) => props.minHeight}px;
  box-sizing: border-box;
  border-radius: ${radius}px;
  font-weight: ${FontWeight.Normal};
  font-size: ${FontSize.Medium};
  resize: none;
  border: none;
  ${prettyScrollbars()};
  overflow: visible;
  background-color: transparent;
  resize: none;
  line-height: inherit;
  display: block;
  color: ${form};
  ::placeholder {
    opacity: 0.7;
    color: ${form};
  }
  max-height: ${({ maxHeight }) => maxHeight && `${maxHeight}px`};
  &:focus {
    border-color: green;
    outline: none !important;
  }
  ${(props) => VARIANTS[props.variant]};
`;

export default function TextArea({
  value,
  onChange,
  placeholder = "",
  maxHeight,
  minHeight = 50,
  className,
  size = "m",
  variant = "secondary",
}: TextAreaProps) {
  const ref = useRef<HTMLTextAreaElement>(null);

  useEffect(() => {
    if (ref?.current) {
      ref.current.style.height = `${ref.current.scrollHeight}px`;
    }
  }, [minHeight, value]);

  return (
    <Input
      className={className}
      ref={ref}
      value={value}
      onChange={(e) => onChange(e.target.value)}
      placeholder={placeholder}
      maxHeight={maxHeight}
      minHeight={minHeight}
      $size={size}
      variant={variant}
    />
  );
}
